import { useRef, useState } from "react";

import ColorStack from "app/components/colorsStack/ColorStack";
import { CHART_COLORS } from "app/constants/ChartColors";

import type { LegendItem } from "../types";
import { getChartConfig } from "../utils";

export const useCommonVisitsOvertime = () => {
    const [legendItems, setLegendItems] = useState<LegendItem[]>([]);
    const colorStack = useRef(new ColorStack(CHART_COLORS.chartMainColors));
    const config = getChartConfig();

    return { legendItems, setLegendItems, colorStack, config };
};
